import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const WettbewerberPreisGroupServiceConfig = {
  name: "WettbewerberPreisGroup",
  annotations: []
} as ServiceConfig;